import messages from '../../const/messages';
import {
    hasInvalidCharsInProjectName
} from './hasInvalidCharsInProjectName';

export function validateProjectName(newName, projects, curName) {
    if (!newName) {
        return 'Enter project name';
    }

    if (!newName.replace(/\s/g, '').length) {
        return 'Project name cannot contain only space characters';
    }

    if (!newName.replace(/\./g, '').length) {
        return 'Project name cannot contain only "." characters';
    }

    if (hasInvalidCharsInProjectName(newName)) {
        return 'Project name can contain only ASCII alphanumeric characters and "-.:())"';
    }

    const projectsToCheck = projects.filter(project => {
        return project.name !== curName;
    });

    if (projectsToCheck.filter(project => project.name.toLowerCase() === newName.toLowerCase()).length) {
        return messages.projectAlreadyExists;
    }
    return null;
}